import { useApplicationContext } from '../applicationContext';

/**
 * Возвращает Date на основе serverTimestamp из контекста.
 * Гарантирует одинаковый результат на сервере и клиенте при гидрации.
 */
export function useServerNow(): Date {
  const { custom } = useApplicationContext();

  return new Date(custom.serverTimestamp ?? Date.now());
}
